import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { subDomainQueries } from '@/services/premiumStores/subDomain/subDomain.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useSubDomainMutation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('createSubDomain', {
    onSuccess: async (data) => {
      toast.success(data.message);
      await queryClient.invalidateQueries({ queryKey: subDomainQueries.all() });
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync };
};
